<template>
  <div @click.self="hideSearch" class="search" :class="{ visible: this.$parent.showSearch }">
    <div class="container">
      <div class="search__box">
        <div class="search__content">
          <h4 :class="{ indent: searched && results.length > 0  }">Search</h4>
          <form @submit.prevent="submit($event)">
            <input @input="searchFor" v-model="search" type="text" name="search" value="" placeholder="Search for products and information..." autocomplete="off">
          </form>
          <div class="search__results">
            <ul>
              <li v-for="result in results">
                <a :href="result.url.match(regex) ? result.url.substring(0, result.url.lastIndexOf('/')) : result.url">{{ result.title }}</a>
              </li>
            </ul>
          </div>
          <a v-if="searched && results.length > 0" :href="`/search?q=${ search.trim() }`" class="block full-width btn btn-primary">All Search results</a>
          <p v-if="search.length >= minSearch && searched && results.length == 0">No results found.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.search {
    position: absolute;
    top: 100%;
    left: 0%;
    width: 100%;
    display: none;
}


.search.visible {
    display: block;
    height: 100vh;
}

.search__box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    background-color: #ffffff;
}

.search__content {
    flex-basis: 90%;
}

.search__content h4,
.search input[name="search"] {
    font-weight: 500;
}

.search__content h4.indent {
    padding-left: 2rem;
}

.search input[name="search"], .search ul li a {
  color: #1A2041;
}

.search input[name="search"] {
    padding-left: 2rem;
    padding-right: 2rem;
    font-size: 1.2rem;
    font-weight: 500;
}

.search__results {
    max-height: 50vh;
    overflow: scroll;
    margin-bottom: 1rem;
}

.search ul {
    padding: 1rem 0;
}

.search ul li {
    padding: 0;
}

.search ul li a {
    display: inline-block;
    width: 100%;
    height: 100%;
    padding: 1rem 2rem;
    background-color: #f6f6f6;
}

.search ul li a:hover {
    background-color: #c5c7cf;
}

.search input[name="search"]::placeholder {
    visibility: hidden;
    color: #5E627A;
    font-weight: 100;
}

@media (min-width: 600px) {
    .search input[name="search"]::placeholder {
        visibility: visible;
    }
}

@media (min-width: 1023px) {
    .search__box {
        padding: 2rem 8rem 6rem 8rem;
    }

    .search__content {
        flex-basis: 70%;
    }
}

@media (min-width: 1400px) {
    .search__results {
        max-height: 60vh;
    }
}

</style>

<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                minSearch: 3,
                regex: /(?:\/products\/accessories)/,
                results: [],
                search: '',
                searched: false
            }
        },
        methods: {
            hideSearch() {
                this.$parent.showOverlay = false;
                this.$parent.showSearch = false;
                this.search = '';
                this.searched = false;
                this.results = [];
                if (document.querySelector('body').classList.contains('ns')) {
                  document.querySelector('body').classList.remove('ns');
                }
            },
            searchFor() {
                this.searched = false;
                if (this.search.length >= 3) {
                    let payload = {
                        q: this.search
                    };

                    axios({
                        method: 'GET',
                        url: `/search.json`,
                        params: payload
                    })
                    .then(response => {
                        this.results = response.data.data;
                        console.log(response);
                    }, response => {
                        console.log('Something went wrong.')
                    });
                }
                this.searched = true;
            },
            submit(e) {
                e.preventDefault();
                if (this.search.length >= this.minSearch) {
                    if (this.$props.site != '') {
                        window.location.href = `${this.$props.site}search?q=${this.search}`;
                    } else {
                        window.location.href = `/search?q=${this.search}`;
                    }
                }
            }
        },
        props: {
            event: Object,
            site: String
        }
    }
</script>
